<div class="container-fluid px-0">
  <div class="row mx-0"
    style="position: relative; height: 30rem; background-image: url('assets/images/group.webp'); background-size: cover; background-position: center;">
    <div class="col-12 d-flex justify-content-center flex-column align-items-center">
      <div class="text-center"
        style="color: #000; text-shadow: 0.5px 0.5px white; background-color: rgba(255, 255, 255, 0.9); width: fit-content; border-radius: 1.5rem; padding: 2rem 3rem 2rem 3rem;">
        <h4 class="mt-1 mb-1" style="color:#000; text-shadow: 0.5px 0.5px white;" i18n>The best professionals</h4>
        <h3 class="mb-2" style="position: relative; top: -0rem;" i18n>At the best prices</h3>
        <!--
        <span class="input-group" style="width: 100%; white-space: nowrap;">
          <span class="input-group-text"><fa-icon [icon]="fa.faSearch"></fa-icon></span>
          <input id="typeahead-prevent-manual-entry" type="text" class="form-control"
            [(ngModel)]="model" [ngbTypeahead]="search" [inputFormatter]="formatter" [resultFormatter]="formatter"
            [editable]="false" (selectItem)="typeaheadSelect($event)" placeholder="Enter your city" i18n-placeholder>
        </span>
        <button (click)="getLocation()" class="btn btn-primary mt-3">
          <fa-icon [icon]="fa.faLocationArrow" style="color: #fff; margin-inline-end: 0.5rem; margin-inline-start: 0;" class="mx-2"></fa-icon>
          <ng-container i18n>Start - Share location</ng-container>
        </button>
        -->
        <a [href]="(organization | translateField: 'customer_youtube_intro_link') || defaultYoutubeLink"
          target="_system" class="d-block d-flex align-items-center justify-content-center" style="margin-top: 0rem;">
          <fa-icon [icon]="faBrands.faYoutube" style="color: #FF0000; font-size: 2rem;"></fa-icon>
          <span class="mx-2" i18n>What is Nuuduu?</span>
        </a>
        <p *ngIf="isLoggedIn === false" class="mt-2 mb-0 text-danger" i18n>15% welcome discount</p>
      </div>
    </div>
  </div>

  <div class="container-fluid mb-2 mt-2">
    <div class="container px-3">
      <h2 class="mt-3 mb-3" i18n>Most popular Nuuduu services</h2>
      <div class="row mx-0 row-cols-1 row-cols-md-2 row-cols-lg-3 g-4 align-items-stretch">
        <ng-container *ngFor="let assignment of popularAssignments; let i = index">
          <div class="col d-flex">
            <div (click)="assignmentOpen(assignment)" class="card h-100 w-100 cursor-pointer"
              style="overflow: hidden; background-image: url('{{assignment.picture}}'); background-size: cover; background-position: 0 25%; height: 11rem;">
              <div class="card-header" style="height: 11rem; border: none;"></div>
              <div class="card-body d-flex flex-column" style="background: rgba(255,255,255,0.9);">
                <h4 class="card-title">{{ assignment | translateField: 'name' }}</h4>
                <p class="card-text">{{ assignment | translateField: 'description_short' }}</p>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid mb-0 mt-0 d-flex justify-content-center">
  <div class="container">
    <h2 class="mt-3 mb-3 cursor-pointer">
      <span i18n>Discover all Nuuduu services</span>

      <!--
      <fa-icon *ngIf="allOpen" class="float-end" [icon]="fa.faChevronDown" style="color: #fff;"></fa-icon>
      <fa-icon *ngIf="!allOpen" class="float-end" [icon]="fa.faChevronRight" style="color: #fff;"></fa-icon>
      -->
    </h2>
    <div *ngIf="allOpen" class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4 align-items-stretch">
      <ng-container *ngFor="let assignment of assignments; let i = index">
        <div class="col d-flex">
          <div (click)="assignmentOpen(assignment)" class="card h-100 w-100 cursor-pointer"
            style="overflow: hidden; background-image: url('{{assignment.picture}}'); background-size: cover; background-position: 0 25%; height: 11rem;">
            <div class="card-header" style="height: 11rem; border: none;"></div>
            <div class="card-body d-flex flex-column" style="background: rgba(255,255,255,0.9);">
              <h4 class="card-title">{{ assignment | translateField: 'name' }}</h4>
              <p class="card-text">{{ assignment | translateField: 'description_short' }}</p>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<div class="container mb-5 mt-4">
  <span class="float-end">
    <h5 *ngIf="organizations.length != 1" (click)="selectOrganization(null)"
      [ngClass]="{ 'cursor-pointer': selectedOrganization != null }" i18n>All countries</h5>
    <h6>{{ selectedOrganization | translateField: 'country' }}</h6>
  </span>

  <h2 class="mt-3 mb-3" i18n>Explore Nuuduu cities</h2>
  <div class="row me-3">
    <div class="col-2 d-none d-md-block">
      <h5 *ngIf="organizations.length != 1" (click)="selectOrganization(null)"
        [ngClass]="{ 'cursor-pointer': selectedOrganization != null }" i18n>All countries</h5>
      <h6>{{ selectedOrganization | translateField: 'country' }}</h6>
    </div>
    <div class="col">
      <div *ngIf="!selectedOrganization" class="row g-3">
        <div *ngFor="let organization of organizations | localeSort: 'country'" class="col-lg-3 col-md-4">
          <button (click)="selectOrganization(organization)" class="btn btn-primary w-100 text-start"
            style="line-height: 2rem;">
            <img [alt]="organization | translateField: 'country'"
              [src]="'assets/images/flags/' + organization.country_code.toLocaleLowerCase() + '.webp'"
              style="height: 2rem; border-radius: 0.5rem;">
            &nbsp;&nbsp;
            {{ organization | translateField: 'country' }}
            &nbsp;&nbsp;
            <fa-icon [icon]="fa.faChevronRight" class="float-end" style="color: #fff;"></fa-icon>
          </button>
        </div>
      </div>
      <div class="row g-3" *ngIf="selectedOrganization">
        <div *ngFor="let city of selectedOrganization.cities" class="col col-lg-2 col-md-3">
          <button (click)="selectCity(city)" class="btn btn-primary w-100 text-start me-3" style="line-height: 2rem;">
            {{ city | translateField: 'name' }}&nbsp;&nbsp;<fa-icon [icon]="fa.faChevronRight" class="float-end"
              style="color: #fff;"></fa-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="card mt-5 mb-3 ms-4 me-4">
  <div class="card-body">
    <div class="row align-items-center">
      <div class="col-md-7 d-flex justify-content-center flex-column">
        <div class="m-auto">
          <h4 style="margin-left: 15%; margin-right: 15%;" class="mb-3" i18n>What is Nuuduu?</h4>
          <h2 style="margin-left: 15%; margin-right: 15%;" class="mb-4" i18n>Freedom from hassle</h2>

          <p style="margin-left: 15%; margin-right: 15%;" i18n>Nuuduu gives you free time and alleviates the hassles
            of
            life.</p>
          <p style="margin-left: 15%; margin-right: 15%;" i18n>Nuuduu lets you order services like cleaning, catering,
            handymen, plumbers, IT technical and
            more right from your smart phone.</p>
        </div>
      </div>
      <div class="col-md-5">
        <img alt="Person relaxing" i18n-alt src="assets/images/relax2.webp" class="img-fluid rounded-1">
      </div>
    </div>
  </div>
</div>

<div *ngIf="platform == 'web'" class="row align-items-center mt-5 mb-4 pt-3 pb-3"
  style="color: #000; background-color: #fff;">
  <div class="col-md-5">
    <img alt="Person using a smartphone" i18n-alt src="assets/images/smartphone.webp" class="img-fluid rounded-1">
  </div>

  <div class="col-md-7 d-flex justify-content-center flex-column">
    <div class="m-auto">
      <h2 style="margin-left: 15%; margin-right: 15%;" class="mb-3 mt-3" i18n>Hundreds services at your fingertips
      </h2>

      <p style="margin-left: 15%; margin-right: 15%;" i18n>
        Get the Nuuduu app and choose from 100+ services and hundreads of Nuuduu partners in all major cities.
      </p>
      <p style="margin-left: 15%; margin-right: 15%;" i18n>
        Discover and get what you want - help is just a click away.
      </p>
      <div>
        <a href="https://apps.apple.com/app/nuuduu/id6745711778" target="_blank"><img alt="Download on the App Store"
            i18n-alt src="assets/images/app-store.png" style="height: 4rem; display: block;" class="mb-3 mx-auto"></a>
        <a href="https://play.google.com/store/apps/details?id=com.nuuduu.customer" target="_blank"><img
            alt="Get it on Google Play" i18n-alt src="assets/images/play-store.png"
            style="height: 4rem; display: block;" class="mb-3 mx-auto"></a>
      </div>
    </div>
  </div>
</div>

<div class="container mb-4 mt-0">
  <div class="row me-0">
    <div class="col-12">
      <h3 class="mb-2" i18n>Look at what our customers are saying</h3>

      <div class="row">
        <div class="col col-md-6 col-lg-4">
          <div (click)="router.navigate(['/partners', feedback.employee.referral_code])"
            *ngFor="let feedback of feedbacks" class="card cursor-pointer mb-3">
            <div class="card-body p-3">
              <div class="row mb-2">
                <div class="col">
                  <span class="float-end" style="position: relative; top: 4px;">{{ feedback.created_at | date:
                    'shortDate'
                    }}</span>
                  <div class="float-start">
                    <fa-icon *ngIf="feedback.rating >= 1" [icon]="fa.faStar" size="lg" style="color: #ffd700;"
                      class="me-1"></fa-icon>
                    <fa-icon *ngIf="feedback.rating >= 2" [icon]="fa.faStar" size="lg" style="color: #ffd700;"
                      class="me-1"></fa-icon>
                    <fa-icon *ngIf="feedback.rating >= 3" [icon]="fa.faStar" size="lg" style="color: #ffd700;"
                      class="me-1"></fa-icon>
                    <fa-icon *ngIf="feedback.rating >= 4" [icon]="fa.faStar" size="lg" style="color: #ffd700;"
                      class="me-1"></fa-icon>
                    <fa-icon *ngIf="feedback.rating >= 5" [icon]="fa.faStar" size="lg" style="color: #ffd700;"
                      class="me-1"></fa-icon>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-auto pe-0">
                  <img [alt]="'Picture of ' + feedback.employee.first_name" [src]="feedback.employee.picture"
                    style="border-radius: 50%; width: 4rem; height: 4rem; object-fit: cover;" class="me-0">
                </div>
                <div class="col ps-2">
                  <p>{{ feedback | translateField: 'feedback' }}</p>
                  <div>
                    {{ feedback.employee.first_name }},
                    <span class="text-muted"><span i18n>Partner since</span>&nbsp;{{ feedback.employee.created_at |
                      date:
                      'MMM yyyy' }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--
  <div class="card mb-3 ms-4 me-4">
    <div class="card-body">
      <div class="row align-items-center">
        <div class="col-md-7 d-flex justify-content-center flex-column">
          <div class="m-auto">
            <h4 style="margin-left: 15%; margin-right: 15%;" class="mb-3" i18n>Don't worry</h4>
            <h2 style="margin-left: 15%; margin-right: 15%;" class="mb-4" i18n>We got you covered</h2>

            <p style="margin-left: 15%; margin-right: 15%;" i18n>All Nuuduu services include accident insurance from Some Insurance Group that protects you from accidental damages.</p>
            <div>
              <img src="assets/images/insurance.png" style="width: 8rem;" class="d-block mx-auto mb-5">
            </div>
          </div>
        </div>
        <div class="col-md-5">
          <img src="assets/images/accident.webp" class="img-fluid">
        </div>
      </div>
    </div>
  </div>
  -->
<div class="card mb-3 ms-4 me-4">
  <div class="card-body">
    <div class="row align-items-center">
      <div class="col-md-5">
        <img alt="Business person" i18n-alt src="assets/images/business.webp" class="img-fluid rounded-1">
      </div>
      <div class="col-md-7 d-flex justify-content-center flex-column">
        <div class="m-auto">
          <h4 class="mb-3 mt-3" i18n>Customer first</h4>
          <h2 class="mb-4" i18n>Order with confidence</h2>

          <p i18n>You can cancel your order up to 24 hours before its start for free.</p>
          <p i18n>If you are not happy with the service you can request a refund up to 30%.</p>
        </div>
      </div>
    </div>
  </div>
</div>
<div style="height: 1rem;"></div>

<ng-container *ngIf="platform == 'web'">
  <div class="col row p-3" style="background-color: #111;">
    <div class="col-6 col-md-3">
      <a routerLink="/"><img alt="Nuuduu logo" i18n-alt src="assets/images/logo-text.webp"
          style="width: 9.5rem; position: relative; left: 0.4rem;" class="mb-3"></a>
      <a href="https://apps.apple.com/app/nuuduu/id6745711778" target="_blank"><img alt="Download on the App Store"
          i18n-alt src="assets/images/app-store.png" style="width: 9.5rem; display: block;" class="mb-3"></a>
      <a href="https://play.google.com/store/apps/details?id=com.nuuduu.customer" target="_blank"><img
          alt="Get it on Google Play" i18n-alt src="assets/images/play-store.png" src="assets/images/play-store.png"
          style="width: 9.5rem; display: block;" class="mb-3"></a>
    </div>
    <div class="col-6 col-md-3 mb-3">
      <h5 i18n>Partner with Nuuduu</h5>
      <a [href]="'/partners/' + locale + '/find-work'" class="d-block" i18n>Find work</a>
      <a [href]="'/partners/' + locale + '/about'" class="d-block" i18n>What is Nuuduu for partners</a>
      <a [href]="'/partners/' + locale + '/signin'" class="d-block" i18n>Start working</a>
    </div>
    <div class="col-6 col-md-3 mb-3">
      <h5 i18n>Useful links</h5>
      <a routerLink="/" class="d-block" i18n>Discover services</a>
      <a routerLink="/about" class="d-block" i18n>What is Nuuduu for customers</a>
      <a routerLink="/signin" class="d-block" i18n>Sign in / Sign up</a>
      <a routerLink="/press" class="d-block" i18n>Press &amp; Media</a>
    </div>
    <div class="col-6 col-md-3">
      <h5 i18n>Follow us</h5>
      <a [href]="(organization | translateField: 'customer_facebook_link') || defaultFacebookLink" target="_blank"
        class="d-block">Facebook</a>
      <a [href]="(organization | translateField: 'customer_x_link') || defaultXLink" target="_blank"
        class="d-block">X</a>
      <a [href]="(organization | translateField: 'customer_youtube_link') || defaultYoutubeChannelLink" target="_blank"
        class="d-block">YouTube</a>
    </div>
  </div>
  <div class="row p-3 align-items-center" style="background-color: #111;">
    <div class="col-4">
      <a (click)="languageSelector()" class="nav-link cursor-pointer" data-bs-dismiss="offcanvas">
        <ng-container *ngIf="organization && organization.country_code">
          <img [alt]="organization | translateField: 'country'"
            [src]="'assets/images/flags/' + organization.country_code.toLocaleLowerCase() + '.webp'"
            style="height: 1rem; border: none; position: relative; top: -1px;" class="me-1">
          {{ locale | i18nSelect: locales }}
        </ng-container>
        <ng-container *ngIf="!organization">
          <fa-icon [icon]="fa.faGlobe" style="color:#fff;"></fa-icon>&nbsp;
          <ng-container i18n>Location</ng-container>
        </ng-container>
      </a>
    </div>
    <div class="col-8 text-end">
      <a href="https://nuuduu.com/privacy" (click)="privacyPolicy(); $event.preventDefault();" class="text-nowrap"
        i18n>Privacy policy</a>&nbsp;&nbsp;
      <a href="https://nuuduu.com/tnc" (click)="tnc(); $event.preventDefault();" class="text-nowrap" i18n>Terms &amp;
        conditions</a>&nbsp;&nbsp;
      <span class="text-nowrap">&copy; Nuuduu UAB {{ copyrightYear }}</span>
    </div>
  </div>
</ng-container>